import { effects } from 'redux-saga'

import { begin, end, receiveError } from '../../modules/loading'
import { receiveServices } from '../../modules/service/reducer'
import callWithHmac from '../effects/callWithHmac'

export default function* loadClient(invocation, action) {
  const clientId = action.payload.clientId

  try {
    yield effects.put.resolve(begin('service-client', clientId))

    const result = yield effects.call(
      callWithHmac,
      invocation.getServicesForClient,
      clientId,
    )

    yield effects.put.resolve(receiveServices(result.services))
  } catch (e) {
    if (!e.response || e.response.status >= 500) {
      throw e
    }

    yield effects.put.resolve(receiveError('service-client', clientId, e))
  } finally {
    yield effects.put.resolve(end('service-client', clientId))
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/service/loadClient.js